import React from 'react';
import ContentContainer from '../../components/LayoutComponents/ContentContainer';
import ImportCollectorLoansConfirm from '../../components/CbsComponents/Imports/CollectorLoans/ImportCollectorLoansConfirm';

const ImportCollectorLoansTable: React.FC = () => {
  const breadcrumbs = [
    {
      title: 'menu.imports',
      href: '#',
    },
    {
      title: 'menu.importCollectorLoans',
      href: `/import/collectorloans`,
    },
  ];
  return (
    <ContentContainer
      helmetTitle="menu.importDisbursements"
      pageTitle="menu.imports"
      breadcrumbs={breadcrumbs}
    >
      <ImportCollectorLoansConfirm />
    </ContentContainer>
  );
};

export default ImportCollectorLoansTable;
